import { Space, useLayoutContext } from "arkh";
import { useMemo } from "react";
import { useSizeClass } from "../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

export function usePLUProductItemLayout() {
  const space: Space = "medium";

  const heightCompact = useSizeClass().height === SizeClass.COMPACT;

  const titleHeight = 60;

  const contentSize = heightCompact ? 40 : 60;
  const barCodeHeight = contentSize;
  const pluFocusHeight = contentSize;
  const extraImageSize = 80;

  const padding = useLayoutContext().space[space];
  return useMemo(
    () => ({
      space,
      padding,
      imageSize: extraImageSize + contentSize + titleHeight + padding * 2,
      barCodeHeight,
      titleHeight,
      pluFocusHeight,
      height: extraImageSize + contentSize + titleHeight + padding * 2,
    }),
    [barCodeHeight, contentSize, padding, pluFocusHeight]
  );
}
